import { render, staticRenderFns } from "./client-forgot-pass.vue?vue&type=template&id=0710ed74"
import script from "./client-forgot-pass.vue?vue&type=script&lang=ts"
export * from "./client-forgot-pass.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0710ed74')) {
      api.createRecord('0710ed74', component.options)
    } else {
      api.reload('0710ed74', component.options)
    }
    module.hot.accept("./client-forgot-pass.vue?vue&type=template&id=0710ed74", function () {
      api.rerender('0710ed74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/client-forgot-pass.vue"
export default component.exports